import { IPagination, IUserState } from '../states';

export const initialUserState: IUserState = {
  value: [],
  isFetchingUsers: true,
  pagination: {} as IPagination,
};
